module.exports = __webpack_public_path__ + "static/media/polea_galvanizada.9d102bb9.jpg";